import { render, staticRenderFns } from "./ComponentPagination.vue?vue&type=template&id=785cd28e&scoped=true&"
import script from "./ComponentPagination.vue?vue&type=script&lang=js&"
export * from "./ComponentPagination.vue?vue&type=script&lang=js&"
import style0 from "./ComponentPagination.vue?vue&type=style&index=0&id=785cd28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785cd28e",
  null
  
)

export default component.exports